import { forwardRef, useImperativeHandle } from "react"
import Temphumigraph from "./temphumigraph.js"
import Raingraph from "./raingraph.js"
import Windgustgraph from "./windgustgraph.js"

const Weathergraphpanel = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    download() { csvdownload() }
  }))

  function formatDate(datetime) {
    if (datetime == null) return null;
    const modified = new Date(datetime);
    const year = modified.getFullYear();
    const month = ("0" + (modified.getMonth() + 1)).slice(-2);
    const date = ("0" + modified.getDate()).slice(-2);
    const hours = ("0" + modified.getHours()).slice(-2);
    const minutes = ("0" + modified.getMinutes()).slice(-2);
    return year + "-" + month + "-" + date + "T" + hours + ":" + minutes;
  };

  function csvdownload() {
    
    const isodate = formatDate(Date.parse(props.data.datetime[0]));
    const filename = "weather_" + isodate.substring(0,4) + isodate.substring(5,7) + isodate.substring(8,10) + ".csv"

    const bom = new Uint8Array([0xef, 0xbb, 0xbf])
    var csv = "isotime,temp[℃],humi[%],wind[m/s],gust[m/s],rain[mm/min]\n";
    for (var i = 0; i < props.data.datetime.length; i++) {
      const date = Date.parse(props.data.datetime[i]);
      csv += (formatDate(date) + "," + props.data.temp[i] + "," + props.data.humi[i] + "," + props.data.wind[i] + "," + props.data.gust[i] + "," + props.data.rain[i] + "\n");
    }
    const blob = new Blob([bom, csv], { type: "text/csv" })
    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(blob)
    link.click()
    URL.revokeObjectURL(link.href)
  }
  return (
    <>
      <Temphumigraph height={200} data={props.data} />
      <Raingraph height={200} data={props.data} />
      <Windgustgraph height={200} data={props.data} />
    </>
  );
})

export default Weathergraphpanel;
